import axios from 'axios';
import { getHomeboxServiceUrl } from '../utils/urlConfig';

const getAuthHeaders = () => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    const parsedUser = JSON.parse(storedUser);
    const token = parsedUser.auth_token || parsedUser.token || parsedUser.jwt;
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  }
  return {};
};

const ActiveScanService = {
  getActiveScan: async () => {
    try {
      const baseUrl = getHomeboxServiceUrl();
      const response = await axios.get(`${baseUrl}/api/active-scan`, {
        headers: getAuthHeaders()
      });
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error('Error fetching active scan:', error);
      return null;
    }
  },

  saveActiveScan: async (state) => {
    try {
      const baseUrl = getHomeboxServiceUrl();
      const response = await axios.post(`${baseUrl}/api/active-scan`, state, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error saving active scan:', error);
      return null;
    }
  },

  clearActiveScan: async () => {
    try {
      const baseUrl = getHomeboxServiceUrl();
      await axios.delete(`${baseUrl}/api/active-scan`, {
        headers: getAuthHeaders()
      });
      return true;
    } catch (error) {
      console.error('Error clearing active scan:', error);
      return false;
    }
  }
};

export default ActiveScanService;
